export default "__VITE_ASSET__AD_dxVbH__"